import Modifier from 'ember-modifier';

export default class UpdateModifier extends Modifier {
  modify(element, [callback, ...args]) {
    callback?.(...args);
  }
}
